import React, { useState, useRef, useEffect } from "react";
import { NumberInput, Panel, SelectPicker, Text, Drawer } from "rsuite";
import { Table, Space, notification, Button, Form, Card, Input } from "antd";
import { LayoutHome } from "./LayoutHome";
import { FaBackward, FaSave } from "react-icons/fa";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import {
  getCatFiltros,
  getStockFiltro,
  getListaFiltros,
  saveEntradaFiltro,
  getClasificaFiltros,
  saveFiltro,
} from "./Services/FiltrosServices";
import moment from "moment/moment";
import { soloNumeros } from "../Utils";

export const Inventario = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [api, contextHolder] = notification.useNotification();

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const [idFiltro, setIdFiltro] = useState("");
  const [clave, setClave] = useState("");
  const [cantidad, setCantidad] = useState(0);
  const [stock, setStock] = useState(0);
  const [listaClasif, setListaClasif] = useState([]);
  const [listaFiltros, setListaFiltros] = useState([
    { label: "", value: null },
    { label: "+ NUEVO FILTRO", value: "0" },
  ]);
  const [listOpcFlujo, setListOpcFlujo] = useState([
    { label: "", value: null },
    { label: "Alto", value: "Alto" },
    { label: "Bajo", value: "Bajo" },
  ]);
  const [data, setData] = useState([]);
  const [dataFiltros, setDataFiltros] = useState([]);
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();

  const initialized = useRef(false);

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{ padding: 8 }}
        onKeyDown={(e) => e.stopPropagation()}
        tabIndex={"-1"}
      >
        <Input
          ref={searchInput}
          autoFocus
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Resetear
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Folio",
      dataIndex: "entrada",
      width: "8%",
      key: "entrada",
      align: "center",
    },
    {
      title: "Fecha entrada",
      dataIndex: "fecha",
      width: "10%",
      key: "fecha",
      align: "center",
      render: (text) => moment(text).format("DD/MM/YYYY"),
    },
    {
      title: "Filtro",
      dataIndex: "filtro",
      key: "filtro",
      width: "25%",
      sorter: (a, b) => a.filtro.length - b.filtro.length,
      ...getColumnSearchProps("filtro"),
    },
    {
      title: "Clave/Serie",
      dataIndex: "claveSerie",
      key: "claveSerie",
      with: "10%",
      align: "center",
      sorter: (a, b) => a.claveSerie.length - b.claveSerie.length,
      ...getColumnSearchProps("claveSerie"),
    },
    {
      title: "Cant. Pedida",
      dataIndex: "cantidad",
      key: "cantidad",
      width: "10%",
      align: "center",
    },
    {
      title: "Stock actúal",
      dataIndex: "stock",
      key: "stock",
      width: "10%",
      align: "center",
    },
  ];

  const columnsFiltros = [
    {
      title: "ID Filtro",
      dataIndex: "idFiltro",
      width: "8%",
      key: "idFiltro",
      align: "center",
    },
    {
      title: "ID Clasifica",
      dataIndex: "idClasifica",
      width: "8%",
      key: "idClasifica",
      align: "center",
    },
    {
      title: "Modelo",
      dataIndex: "modelo",
      width: "8%",
      key: "modelo",
      align: "center",
    },
    {
      title: "Descripción",
      dataIndex: "descripcion",
      width: "30%",
      key: "descripcion",
      sorter: (a, b) => a.descripcion.length - b.descripcion.length,
    },
    {
      title: "Marca",
      dataIndex: "marca",
      width: "8%",
      key: "marca",
      align: "center",
    },
  ];

  const loadFiltros = async () => {
    setListaFiltros([
      { label: "", value: null },
      { label: "+ NUEVO FILTRO", value: "0" },
    ]);
    await getCatFiltros(idNegocio, 1).then(async (res) => {
      setListaFiltros((prev) => [...prev, ...res]);
      await getListaFiltros(idNegocio).then((res) => {
        setData(res);
      });
    });
  };

  const loadListaFiltros = async () => {
    await getCatFiltros(idNegocio, 2).then(async (res) => {
      setDataFiltros(res);
      await getClasificaFiltros(idNegocio).then((res) => {
        setListaClasif(res);
        setOpen(true);
      });
    });
  };

  const setStockFiltro = async (idFil) => {
    if (idFil === "0") {
      loadListaFiltros();
      return;
    }
    setIdFiltro(idFil);
    await getStockFiltro(idNegocio, idFil).then((res) => {
      setStock(res);
    });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const validateMessages = {
    required: "* Obligatorio",
    types: {
      email: "* El campo de correo no es valido",
      number: "* El campo no es un número!",
    },
    number: {
      range: "${label} must be between ${min} and ${max}",
    },
  };

  const save = async () => {
    const data = {
      id: idNegocio,
      idUSer: idUser,
      idFiltro: idFiltro,
      claveSerie: clave,
      cantidad: cantidad,
    };

    await saveEntradaFiltro(data).then(async (res) => {
      if (res.data > 0) {
        loadFiltros();
        setIdFiltro(null);
        setClave("");
        setCantidad(0);
        setStock(0);
        successNotification(
          "Entrada Filtro",
          "Se ha registrado la entrada de forma correcta.",
        );
        await getListaFiltros(idNegocio).then((res) => {
          setData(res);
        });
      } else {
        errorNotificaction("Error_Entrada", "Error al grabar la entrada.");
      }
    });
  };

  const cleanForm = () => {
    form.resetFields();
  };

  const saveDatosFiltro = async (values) => {
    const newObj = { ...values, id: idNegocio };
    await saveFiltro(newObj).then((res) => {
      if (res.data > 0) {
        successNotification(
          "Alta Filtro",
          "Los datos se han registrado de forma correcta.",
        );
        loadListaFiltros().then(async (res) => {
          cleanForm();
          loadFiltros();
        });
      } else {
        errorNotificaction("Error_SaveFiltro", "Error al grabar los datos...");
      }
    });
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadFiltros();
    }
  }, []);

  return (
    <>
      <title>Inventario de Filtros</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Inicio
              </a>
            ),
          },
          { title: "Inventario de Filtros" },
        ]}
        selectedKey={"6.1"}
      >
        {contextHolder}
        <Panel header="Registro de Entradas (Filtro)" bordered>
          <div className="row mb-2">
            <div className="col-lg-5 col-md-5 col-sm-5">
              <Text>Filtro</Text>
              <SelectPicker
                key={"filtroEntrada"}
                block
                placeholder="-- Selecciona --"
                value={idFiltro}
                data={listaFiltros}
                onChange={(e) => setStockFiltro(e)}
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text>Clave o Serie</Text>
              <Input
                value={clave}
                onChange={(e) => setClave(e.target.value)}
                disabled={idFiltro !== null ? false : true}
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text>Cantidad a ingresar</Text>
              <Input
                style={{ textAlign: "center" }}
                value={cantidad}
                onChange={(e) => setCantidad(soloNumeros(e))}
                disabled={clave.length === 0 ? true : false}
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text>Stock actúal</Text>
              <Input value={stock} readOnly style={{ textAlign: "center" }} />
            </div>
            <div className="text-end col-lg-1 col-md-1 col-sm-1">
              <br></br>
              <Button
                appearance="primary"
                onClick={save}
                icon={<FaSave></FaSave>}
                disabled={Number(cantidad) > 0 ? false : true}
              >
                Guardar
              </Button>
            </div>
          </div>
        </Panel>
        <br></br>
        <Panel header="Inventario de Filtros" bordered>
          <Table
            size="small"
            bordered
            rowKey={(record) => record.idFiltro}
            columns={columns}
            dataSource={data}
            pagination={{ pageSize: 10 }}
          />
        </Panel>

        <Drawer size={"lg"} open={open} onClose={() => setOpen(false)}>
          <Drawer.Header>
            <Drawer.Title>Nuevo Filtro</Drawer.Title>
            <Drawer.Actions>
              <Button
                startIcon={<FaBackward></FaBackward>}
                onClick={() => setOpen(false)}
              >
                Regresar
              </Button>
            </Drawer.Actions>
          </Drawer.Header>
          <Drawer.Body>
            <Card>
              <Form
                name="basic"
                form={form}
                layout="vertical"
                variant="outlined"
                initialValues={{ remember: true }}
                onFinish={saveDatosFiltro}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                validateMessages={validateMessages}
              >
                <div className="row mb-2">
                  <div className="col-lg-3 col-md-3 col-sm-3">
                    <Form.Item
                      name="idFiltro"
                      label={"ID Filtro"}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <Form.Item
                      name="idClasif"
                      label="Clasificación"
                      rules={[{ required: true }]}
                    >
                      <SelectPicker
                        block
                        data={listaClasif}
                        searchable={false}
                        placeholder="-- Selecciona --"
                      />
                    </Form.Item>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-3">
                    <Form.Item
                      name={"opcionFlujo"}
                      label="Opción de Flujo"
                      rules={[{ required: true }]}
                    >
                      <SelectPicker
                        block
                        searchable={false}
                        data={listOpcFlujo}
                        placeholder="-- Selecciona --"
                      />
                    </Form.Item>
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-2">
                    <Form.Item
                      name={"modelo"}
                      label="Modelo"
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <Form.Item
                      name={"descripcion"}
                      label="Descripción"
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-3">
                    <Form.Item name={"marca"} label="Marca">
                      <Input />
                    </Form.Item>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-3">
                    <Form.Item name={"tipo"} label="Tipo">
                      <Input />
                    </Form.Item>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-lg-8 col-md-8 col-sm-8">
                    <Form.Item name={"funcion"} label="Función">
                      <Input />
                    </Form.Item>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <Form.Item name={"membranas"} label="Membranas">
                      <Input />
                    </Form.Item>
                  </div>
                </div>
                <div className="row">
                  <div className="text-end col">
                    <Button
                      icon={<FaSave></FaSave>}
                      htmlType="submit"
                      type="primary"
                    >
                      Guardar
                    </Button>
                  </div>
                </div>
              </Form>
            </Card>
            <br></br>
            <Card title="Catálogo de Filtros">
              <div className="row">
                <div className="col">
                  <Table
                    bordered
                    size="small"
                    rowKey={(record) => record.idFiltro}
                    columns={columnsFiltros}
                    dataSource={dataFiltros}
                    pagination={{ pageSize: 5 }}
                  />
                </div>
              </div>
            </Card>
          </Drawer.Body>
        </Drawer>
      </LayoutHome>
    </>
  );
};
